import React, { useState } from 'react'
import CommonFIlterButton from '../../../../../Common/commonFilterButton/CommonFIlterButton'
// import { modulesforAlerts, Shifts, ViolationSeverity } from '../../../../../../Data/staticData/data'
import { dateChoose } from '../../../../../Screens/GlobalUser/AIModelReports/Components/data/staticData'
import { Button, FormGroup, Input, Card } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";

/** Custom range only for False Alert screen; keep shared `dateChoose` unchanged for other pages. */
const falseAlertDateOptions = [...dateChoose, 'Custom'];

export default function FalseAlertFilters({ cameras, subanalysis, selectedModule, analysis, maxWeek, role, style, areas, subarea, modulesforAlerts, Shifts, shiftsLoading, ViolationSeverity, selectedOption, handleDateDrop, currentWeekk, handleNewInputChange, newFilters, dateShow, monthShow, weeklyShow, customDate }) {
  const rolee = JSON.parse(localStorage.getItem('role')) 

  

  
  return (
    <>

      {
        <Input
          className="rounded-3"
          style={style}
          value={newFilters?.approval || 'Select Approval'}
          type='select'
          onChange={(e) => handleNewInputChange(e, 'approval')}
        >
          {(role == 'qa' || role == 'aitechqa') ? (
            <>
              <option value={'Select Approval'}>Select Approval</option>
              <option value={'Verified'}>Verified</option>
              <option value={'Accepted'}>Accepted</option>
              <option value={'Rejected'}>Rejected</option>
              <option value={'Unverified'}>Unverified</option>
            </>
          ) : (
            <>
              <option value={'Select Approval'}>Show All Alerts</option>
              <option value={'Accepted'}>Accepted</option>
            </>
          )}
        </Input>
      }

      {
        modulesforAlerts &&
        <Input
          className={`rounded-3`}
          type="select"
          name="role"
          id="role"
          style={style}
          value={selectedModule?.module_name  || ''}
          onChange={(e) => handleNewInputChange(e, "module")}
        >
          <option value="">Select Modules</option> 
          {modulesforAlerts &&
            modulesforAlerts?.map((item, index) => (
              <option style={{ width: '80%' }} className="ellipsis-textt" key={index} value={item?.module_name}>
                {item?.module_name}
              </option>
            ))}
        </Input>
      }

      {
  <Input
  className={["checker","incharge","supervisor"].includes(role) ? 'd-none' : 'rounded-3'}
  type="select"
  name="status"
  id="status"
  style={style}
  value={newFilters?.status || ""}     // <-- direct string
  onChange={(e) => handleNewInputChange(e, "status")}
>
  <option value="">Select Status</option>
  <option value="accepted">Accepted</option>
  <option value="rejected">Rejected</option>
  <option value="verified">Verified</option>
  <option value="unverified">Unverified</option>

</Input>
}

{
  <Input
  className="rounded-3"
  type="select"
  name="location"
  id="location"
  style={style}
  value={newFilters?.location || ""} 
  onChange={(e) => handleNewInputChange(e, "location")}
>
  <option value="">Select Location</option>
  <option value="indoor">Indoor</option>
  <option value="outdoor">Outdoor</option>
</Input>

}



      {
        ViolationSeverity &&
        <div className="" >
          <CommonFIlterButton
            data={ViolationSeverity}
            handleInputChange={handleNewInputChange}
            style={style}
            selectedItem={newFilters?.severity}
            firstOption={"Select Severity"}
            inputChangeOption={"severity"}
          />
        </div>
      }
      {
        Shifts &&
        <div className=" ">
          <Input
            type="select"
            onChange={(e) => handleNewInputChange(e, 'shift')}
            style={style}
            value={newFilters?.shift || ''}
            disabled={shiftsLoading}
          >
            <option value="">
              {shiftsLoading ? "Loading..." : "Select Shift"}
            </option>
            {Shifts?.map((shift) => (
              <option value={shift.shift_id} key={shift.shift_id}>
                {shift.name}
              </option>
            ))}
          </Input>
        </div>
      }
      {

        (role !== 'area' && analysis === undefined && subanalysis == undefined) &&
        (
          <>

            {
              areas &&
              <div className=" ">
                <Input
                  type="select"
                  onChange={(e) => handleNewInputChange(e, 'area')}
                  style={style}
                  value={newFilters?.area || ''} // Set selected value
                >
                  {/* Default option */}
                  <option value={''}>
                    Select Area
                  </option>
                  {
                    areas
                      ?.filter((a) => a.active === true) // Filter active areas
                      ?.map((opt) => {
                        // Map to options

                        return (
                          <option value={opt?.area} key={opt?.id}>
                            {opt?.area}, {opt?.areaOwner}
                          </option>
                        );
                      })
                  }


                </Input>

              </div>
            }
          </>
        )

      }
      {
        (newFilters?.area!=='' || role=='area') &&
        (
          <>

            {
              subanalysis === undefined &&

              <div>
                <Input
                  type="select"
                  onChange={(e) => handleNewInputChange(e, 'subarea')}
                  style={style}
                  value={newFilters?.subarea || ''} // Set selected value
                >
                  {/* Default option */}
                  <option value={''}>
                    Select Subarea
                  </option>
                  {
                    subarea
                      ?.map((opt) => {
                        return (
                          <option value={opt?.name} key={opt?.id}>
                            {opt?.name}
                          </option>
                        );
                      })
                  }


                </Input>

                {/* <CommonFIlterButton
                  data={subarea?.map(item =>
                    item.name.replace(/\b\w/g, char => char.toUpperCase())
                  )}
                  handleInputChange={handleNewInputChange}
                  style={style}
                  selectedItem={newFilters?.subarea}
                  firstOption={"Sub Area"}
                  inputChangeOption={"subarea"}
                /> */}
              </div>
              
            }
          </>
        )
      }


      {/* {
        cameras &&
        <Input
          className={`rounded-3`}
          type="select"
          name="role"
          id="role"
          style={style}
          value={newFilters.camera_id || ''}
          onChange={(e) => handleNewInputChange(e, "camera_id")}
        >
          <option value="">Select Camera ID</option> 
          {cameras &&
            cameras?.map((item, index) => (
              <option style={{ width: '80%' }} className="ellipsis-textt" key={index} value={item}>
                {item}
              </option>
            ))}
        </Input>
      } */}
      <div className=''>

        <Input
          className=" rounded-3"
          type="select"
          name="role"
          id="role"
          style={style}
          value={selectedOption}
          onChange={handleDateDrop} // Make sure it's `onChange` not `OnChange`
        >
          {falseAlertDateOptions.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </Input>

      </div>
      {dateShow && (
        <>
          <Input
            className="form-control rounded-3"
            type="date"
            name="role"
            id="role"
            max={new Date().toLocaleDateString("en-CA")}
            value={newFilters.date}
            style={style}
            onChange={(e) => handleNewInputChange(e, "date")}
          />
        </>
      )}
      {monthShow && (
        <>
          <Input
            className="form-control rounded-3"
            type="month"
            name="month"
            id="role"
            max={new Date().toISOString().slice(0, 7)}
            value={newFilters.month}
            style={style}
            onChange={(e) => handleNewInputChange(e, "month")}
          />
        </>
      )}
      {weeklyShow && (
        <>
          <Input
            className="form-control  rounded-3"
            type="week"
            name="week"
            id="week"
            max={maxWeek}
            value={newFilters?.week}
            style={style}
            onChange={(e) => handleNewInputChange(e, "week")}
          />
        </>
      )}
      {customDate && (
        <>
          <div className="">
            <Input
              className="form-control rounded-3 "
              type="date"
              name="start_date"
              id="start_date"
              multiple={true}
              max={new Date().toLocaleDateString("en-CA")}
              value={newFilters?.starting}
              style={style}
              onChange={(e) => handleNewInputChange(e, "starting")}
            />
            {/* <p className="m-0 p-0  ">To</p> */}
            <Input
              className="form-control rounded-3 mt-2"
              type="date"
              name="end_date"
              id="end_date"
              placeholder="End Date"
              // disabled={filters?.start_date?.trim() === ""}
              // min={filters?.start_date}
              max={new Date().toLocaleDateString("en-CA")}
              value={newFilters?.ending}
              style={style}
              onChange={(e) => handleNewInputChange(e, "ending")}
            />
            {/* <Button
                    color="success"
                    style={{
                      padding: "0px 10px",
                      height: "38px",
                      // margin: "10px 3px",
                    }}
                    // onClick={() => fetchCustomDurationAlerts()}
                  >
                    Save
                  </Button> */}
          </div>
        </>
      )}

    </>
  )
}
